<div class="p-4 md:p-8 step-container-mobile-pad" style="max-width: 520px; margin: 0 auto;">

  <!-- Header con progreso -->
  <div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; padding: 16px 20px; margin-bottom: 20px;">
    <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px;">
      <button type="button" class="btn-tactil" (click)="previousStep()"
        [disabled]="isTransitioning"
        [style.opacity]="isTransitioning ? '0.5' : '1'"
        style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 8px; font-weight: 600; font-size: 0.8rem; cursor: pointer;"
        onmouseover="if(!this.disabled)this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #374151;">arrow_back</mat-icon>
        Atrás
      </button>
      <span style="background: #1C593D; color: white; padding: 4px 14px; border-radius: 20px; font-size: 0.8rem; font-weight: 700;">
        Paso {{ currentStep }}/{{ totalSteps }}
      </span>
    </div>
    <div style="width: 100%; height: 8px; background: #dcfce7; border-radius: 20px; overflow: hidden;">
      <div style="height: 100%; background: #1C593D; border-radius: 20px; transition: width 0.3s ease;"
        [style.width.%]="(currentStep / totalSteps) * 100"></div>
    </div>
  </div>

  <!-- Step 1: Calculadora -->
  <div *ngIf="currentStep === 1" class="step-slide" [class.slide-in-left]="slideDirection === 'left'" [class.slide-in-right]="slideDirection === 'right'">
    <div style="text-align: center; margin-bottom: 20px;">
      <h2 style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 0 0 4px;">Comprar USDT</h2>
      <p style="font-size: 0.8rem; color: #6b7280; margin: 0;">Calcula tu conversión CLP → USDT</p>
    </div>
    <app-calculator-crypto
      #calculatorComponent
      (clpCurrencyEmit)="assignClp($event)"
      (usdCurrencyEmit)="assignUsd($event)"
      (onBuyClick)="onBuyClicked($event)"
      [usdt_clp_tax]="usdt_clp_tax"
      [desdeTasa]="desdeTasa"
      [ahorroClp]="ahorroClp"
      [escaleraClp]="escaleraClp"
      [baseTramos]="baseTramosClp"
      [precioCorteTramos]="precioCorteClp"
      [cotizarUsdt]="cotizarUsdt"
      [saldoActual]="saldoActual"
      [sobregiroDisponible]="sobregiroDisponible"
      [saldoContable]="saldoContable"
      [lineaCreditoBloqueada]="lineaCreditoBloqueada"
      [lineaCredito]="lineaCredito">
    </app-calculator-crypto>
  </div>

  <!-- Step 2: Beneficiario -->
  <div *ngIf="currentStep === 2" class="step-slide" [class.slide-in-left]="slideDirection === 'left'" [class.slide-in-right]="slideDirection === 'right'">
    <div style="text-align: center; margin-bottom: 20px;">
      <h2 style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 0 0 4px;">Beneficiario</h2>
      <p style="font-size: 0.8rem; color: #6b7280; margin: 0;">Selecciona o agrega tu beneficiario</p>
    </div>
    <app-beneficiary
      (changeStep)="nextStep($event)"
      (beneficiarioOutput)="assignBeneficiario($event)"
      (goBack)="previousStep()">
    </app-beneficiary>
  </div>

  <!-- Step 3: Resumen -->
  <div *ngIf="currentStep === 3" class="step-slide" [class.slide-in-left]="slideDirection === 'left'" [class.slide-in-right]="slideDirection === 'right'">
    <div style="text-align: center; margin-bottom: 20px;">
      <h2 style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 0 0 4px;">Resumen de Orden</h2>
      <p style="font-size: 0.8rem; color: #6b7280; margin: 0;">Revisa que todos los datos estén bien</p>
    </div>
    <app-summary-order
      [clpCurrency]="clpCurrency"
      [usdCurrency]="usdCurrency"
      [usdt_clp_tax]="usdt_clp_tax"
      [beneficiario]="beneficiario"
      [valorCambioId]="valorCambioId"
      [verificarOperacion]="operacionSigueAbierta"
      (goBack)="previousStep()">
    </app-summary-order>
  </div>

</div>
